'use strict';

var _ = require('lodash');
var PricingAnalysisPanelDirective = function PricingAnalysisPanelDirective(pricingAnalysisCommonsDataService) {
  return {
    restrict: 'E',
    template: require('../templates/pricing-analysis-panel.html'),
    replace: true,
    controller: 'PricingAnalysisPanelController',
    link: function link(scope) {
      scope.setDataFromDashboard();
      scope.$on('chart:lengthOfStay:selected', function (evt, referenceService, originalService) {
        scope.isDetailsLengthOfStayGridVisible = true;
        scope.isCompetitorDataGridVisible = isSourceMatching(referenceService) && isOriginalRecommendation(originalService);
      });
      scope.$on('chart:services:selectedService', function (evt, originalService) {
        scope.isServicesPanelVisible = true;
        if (pricingAnalysisCommonsDataService.isSingleItinerary(originalService)) {
          scope.isLengthOfStayChartVisible = false;
        } else {
          scope.isLengthOfStayChartVisible = true;
          return;
        }
        scope.isDetailsLengthOfStayGridVisible = true;
        scope.isCompetitorDataGridVisible = false;
      });
      scope.$on('chart:services:noData', hideElements);
      scope.$on('chart:DepartureDate:reset', hideElements);
      scope.$on('chart:DepartureDate:filterUpdate', hideElements);
      scope.$on('chart:LengthOfStay:dataSize', function (e, lengthOfStaySize) {
        if (lengthOfStaySize === 1) {
          scope.isDetailsLengthOfStayGridVisible = true;
        } else {
          scope.isDetailsLengthOfStayGridVisible = false;
          scope.isCompetitorDataGridVisible = false;
        }
      });
      scope.$on('search-criteria:onSearchButtonClick', function () {
        scope.onSearchButtonClick();
      });
      scope.$on('network-analysis:dataLoaded', function () {
        scope.setSnapshotDate();
        scope.setRunNumber();
      });
      function hideElements() {
        scope.$evalAsync(function () {
          scope.isServicesPanelVisible = false;
          scope.isDetailsLengthOfStayGridVisible = false;
          scope.isCompetitorDataGridVisible = false;
        });
      }
      function isSourceMatching(referenceService) {
        return ['SHOPPINGDATA', 'COMPETITORFARE', 'ORGANIC'].indexOf(referenceService.source) > -1;
      }
      function isOriginalRecommendation(originalService) {
        return !originalService.carryCount;
      }
    }
  };
};
PricingAnalysisPanelDirective.$inject = ['PricingAnalysisCommonsDataService'];
module.exports = PricingAnalysisPanelDirective;